// extracted by mini-css-extract-plugin
module.exports = {"checkboxEstrangeiro":"CadastroClienteSeguroAventuraPropriedade_checkboxEstrangeiro__1HqSh"};